import { render, staticRenderFns } from "./laserCuttingMachine.vue?vue&type=template&id=6c8c5d74&scoped=true&"
import script from "./laserCuttingMachine.vue?vue&type=script&lang=ts&setup=true&"
export * from "./laserCuttingMachine.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./laserCuttingMachine.vue?vue&type=style&index=0&id=6c8c5d74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8c5d74",
  null
  
)

export default component.exports